export const SAMPLES_MODAL_DEFAULT_OPTIONS = {
  bottomModalOnMobile: true,
  warnOnClose: true,
  styleOverride: {
    maxWidth: '100%',
    width: '570px',
  },
};
